<template lang="pug">
div(id='extend-shipping-offer' class='max-h-[50px] my-6')
</template>
<script setup lang="ts">
const cartStore = useCartStore()
const isWaiting = inject<Ref<boolean>>('isWaiting', ref(false))
const notifications = useNotifications()

onMounted(async () => {
  await waitUntilTrue(() => !!window.Extend)

  // without this destroy, the widget will render once, and if you go to a diff page, then come back it will not render again even though the proper DOM nodes exist.
  window.Extend.shippingProtection.destroy()

  window.Extend.shippingProtection.render({
    ...getCartInfo(),
    selector: '#extend-shipping-offer',
    async onEnable() {
      isWaiting.value = true
      try {
        await cartStore.addShippingProtection()
      } catch (error) {
        notifications.addError('Error', 'Failed to add shipping protection.  Please try again.')
      }

      isWaiting.value = false
    },
    async onDisable() {
      isWaiting.value = true
      try {
        await cartStore.removeShippingProtection()
      } catch (error) {
        notifications.addError('Error', 'Failed to remove shipping protection.  Please try again.')
      }

      isWaiting.value = false
    },
    convertQuoteToFormattedDisplayPrice: function (quote: any) {
      return formatCents(quote.premium)
    },
  })
})

watch(
  () => cartStore.cart.total,
  () => {
    window.Extend.shippingProtection.update(getCartInfo())
  }
)

function getCartInfo() {
  const items = cartStore.cart.items.map((item) => {
    return {
      referenceId: item.sku,
      quantity: item.qty,
      purchasePrice: item.salePrice,
      productName: item.productLineName,
      category: item.category,
      shippable: true,
    }
  })

  return {
    items,
    isShippingProtectionInCart: cartStore.cart.hasShippingProtection,
  }
}
</script>
<style>
.extend-shipping {
  padding: 0 !important;
}
</style>
